import { HStack, Text, VStack } from "@chakra-ui/react";
import { Image } from "../reusables";
import dayjs from "../../helpers/dayJs";
import { HiMusicalNote } from "react-icons/hi2";

/**
 *
 * @param {Object} props
 * @param {string} props.objectID
 * @param {string} props.username
 * @param {string} props.userId
 * @param {string} props.title
 * @param {number} props.duration
 * @param {string} props.thumbnailFilename
 * @param {'normal' | 'xs'} props.size
 * @param {import("@chakra-ui/react").StackProps} props.containerProps
 * @returns
 */
const SearchPostItem = ({
  objectID,
  username,
  userId,
  duration,
  title,
  thumbnailFilename,
  containerProps,
  size,
}) => {
  return (
    <HStack
      w="full"
      h="max-content"
      spacing={"3"}
      _hover={{
        background: "#313134",
      }}
      px="2"
      py="1.5"
      cursor={"pointer"}
      {...containerProps}
    >
      {size === "xs" ? (
        <HiMusicalNote size={12} />
      ) : (
        <Image
          firebaseStoragePath={`photos/${userId}/${objectID}/thumbnails/${thumbnailFilename}`}
          h="40px"
          w="40px"
          borderRadius={"md"}
        />
      )}
      <VStack align={"flex-start"} spacing={"0"}>
        <Text
          fontSize={"12px"}
          fontWeight={"semibold"}
          color="white"
          noOfLines={1}
        >
          {title}
        </Text>

        <Text fontSize={"xs"} color="gray.400">
          {dayjs.utc(duration * 1000).format("mm:ss")} - by {username}
        </Text>
      </VStack>
    </HStack>
  );
};

export default SearchPostItem;
